import React from 'react';
import ReactDOM from 'react-dom/client';
import './W3.css'
import './index.css';
import App from './App';
import CookieConsent from "react-cookie-consent";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <CookieConsent
      location="bottom"
      buttonText="Entendido"
      cookieName="myAwesomeCookieName2"
      style={{ background: "#2B373B" }}
      buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
      expires={150}
    >
      Esta web utiliza cookies para mejorar la experiencia del usuario.
    </CookieConsent>
  </React.StrictMode>
);
